import { MY_ONLINE_RETURN } from "../constants/ActionTypes";

const initialMyAccountOnlineReturnState = {
    MY_ONLINE_RETURN_NOW_YEAR : 2010,
    MY_ONLINE_RETURN_STATUS_TYPE_MODULE : '',
    MY_ONLINE_RETURN_STATUS_TYPE : [1,0,0],
    MY_ONLINE_RETURN_TIME_MODULE_SHOW : false,
    MY_ONLINE_RETURN_NOW_TIME_VALUE : '最近三个月订单',
    MY_ONLINE_RETURN_NOW_TIME_VALUE_CODE : 'Q',
    MY_ONLINE_RETURN_NOW_STATUS_CODE : '',
    MY_ONLINE_RETURN_PAGE_CURRENT : 1,
    MY_ONLINE_RETURN_PAGE_TOTAL : 0,
    MY_ONLINE_RETURN_LIST_MODULE : [],
    MY_ONLINE_RETURN_SHOW_COMMENTS : false,
    MY_ONLINE_RETURN_STATUS_MODULE_SHOW : false,
    MY_ONLINE_RETURN_NOW_STATUS_VALUE : '全部状态',
    MY_ONLINE_RETURN_COMMENTS_NOW_OP : '',
    MY_ONLINE_RETURN_COMMENTS_NOW_ORDER_ID : '',
    MY_ONLINE_RETURN_COMMENTS_NOW_SKUID : '',
    MY_ONLINE_RETURN_NOW_PAY_ORDER_ID : '',
    MY_ONLINE_RETURN_NOW_PAY_MONEY : '',
    MY_ONLINE_RETURN_DOWN_PAY_BOX_SHOW : false,
    MY_ONLINE_RETURN_CANCEL_REASON_SHOW : false,
    MY_ONLINE_RETURN_ORDER_ID: '',
    MY_ONLINE_RETURN_LOGISTIC_SHOW : false,
    MY_ONLINE_RETURN_LOGISTIC_MODEL : '',
    MY_ONLINE_RETURN_LOGISTIC_INDEX : null,
    MY_ONLINE_RETURN_CANCEL_REASON_STATUS : null,
    MY_ONLINE_RETURN_USER_PROFILE:null
};

export default function ( state = initialMyAccountOnlineReturnState, action = {} ){

    switch( action.type ){
        
        case MY_ONLINE_RETURN.MY_ONLINE_RETURN_STATUS_TYPE_MODULE:
        return Object.assign({},state,{
            MY_ONLINE_RETURN_STATUS_TYPE_MODULE : action.MY_ONLINE_RETURN_STATUS_TYPE_MODULE
        });
        break;

        case MY_ONLINE_RETURN.MY_ONLINE_RETURN_NOW_YEAR:
        return Object.assign({},state,{
            MY_ONLINE_RETURN_NOW_YEAR : action.MY_ONLINE_RETURN_NOW_YEAR
        });
        break;

        case MY_ONLINE_RETURN.MY_ONLINE_RETURN_LIST_MODULE:
        return Object.assign({},state,{
            MY_ONLINE_RETURN_LIST_MODULE : action.MY_ONLINE_RETURN_LIST_MODULE,
            MY_ONLINE_RETURN_PAGE_TOTAL : action.MY_ONLINE_RETURN_PAGE_TOTAL,
            MY_ONLINE_RETURN_SHOW_COMMENTS : action.MY_ONLINE_RETURN_SHOW_COMMENTS,
        });
        break;

        case MY_ONLINE_RETURN.MY_ONLINE_RETURN_HISTORY:
        return Object.assign({},state,{
            MY_ONLINE_RETURN_PAGE_CURRENT : action.MY_ONLINE_RETURN_PAGE_CURRENT,
            MY_ONLINE_RETURN_NOW_TIME_VALUE : action.MY_ONLINE_RETURN_NOW_TIME_VALUE,
            MY_ONLINE_RETURN_NOW_TIME_VALUE_CODE : action.MY_ONLINE_RETURN_NOW_TIME_VALUE_CODE,
            MY_ONLINE_RETURN_NOW_STATUS_VALUE : action.MY_ONLINE_RETURN_NOW_STATUS_VALUE,
            MY_ONLINE_RETURN_NOW_STATUS_CODE : action.MY_ONLINE_RETURN_NOW_STATUS_CODE,
            MY_ONLINE_RETURN_STATUS_TYPE : action.MY_ONLINE_RETURN_STATUS_TYPE
        });
        break;

        case MY_ONLINE_RETURN.MY_ONLINE_RETURN_NEW_TIME:
        return Object.assign({},state,{
            MY_ONLINE_RETURN_PAGE_CURRENT : action.MY_ONLINE_RETURN_PAGE_CURRENT,
            MY_ONLINE_RETURN_NOW_TIME_VALUE : action.MY_ONLINE_RETURN_NOW_TIME_VALUE,
            MY_ONLINE_RETURN_NOW_TIME_VALUE_CODE : action.MY_ONLINE_RETURN_NOW_TIME_VALUE_CODE,
            MY_ONLINE_RETURN_TIME_MODULE_SHOW : action.MY_ONLINE_RETURN_TIME_MODULE_SHOW,
        });
        break;

        case MY_ONLINE_RETURN.MY_ONLINE_RETURN_TIME_MODULE_SHOW:
        return Object.assign({},state,{
            MY_ONLINE_RETURN_TIME_MODULE_SHOW : action.MY_ONLINE_RETURN_TIME_MODULE_SHOW,
        });
        break;

        case MY_ONLINE_RETURN.MY_ONLINE_RETURN_STATUS_TYPE:
        return Object.assign({},state,{
            MY_ONLINE_RETURN_STATUS_TYPE : action.MY_ONLINE_RETURN_STATUS_TYPE,
        });
        break;

        case MY_ONLINE_RETURN.MY_ONLINE_RETURN_NEW_STATUS:
        return Object.assign({},state,{
            MY_ONLINE_RETURN_PAGE_CURRENT: action.MY_ONLINE_RETURN_PAGE_CURRENT,
            MY_ONLINE_RETURN_NOW_STATUS_VALUE: action.MY_ONLINE_RETURN_NOW_STATUS_VALUE,
            MY_ONLINE_RETURN_NOW_STATUS_CODE: action.MY_ONLINE_RETURN_NOW_STATUS_CODE,
            MY_ONLINE_RETURN_STATUS_MODULE_SHOW: action.MY_ONLINE_RETURN_STATUS_MODULE_SHOW,
        });
        break;

        case MY_ONLINE_RETURN.MY_ONLINE_RETURN_STATUS_MODULE_SHOW:
        return Object.assign({},state,{
            MY_ONLINE_RETURN_STATUS_MODULE_SHOW: action.MY_ONLINE_RETURN_STATUS_MODULE_SHOW,
        });
        break;

        case MY_ONLINE_RETURN.MY_ONLINE_RETURN_NEW_TAB:
        return Object.assign({},state,{
            MY_ONLINE_RETURN_PAGE_CURRENT: action.MY_ONLINE_RETURN_PAGE_CURRENT,
            MY_ONLINE_RETURN_NOW_STATUS_VALUE: action.MY_ONLINE_RETURN_NOW_STATUS_VALUE,
            MY_ONLINE_RETURN_NOW_STATUS_CODE: action.MY_ONLINE_RETURN_NOW_STATUS_CODE,
            MY_ONLINE_RETURN_STATUS_TYPE: action.MY_ONLINE_RETURN_STATUS_TYPE,
        });
        break;

        case MY_ONLINE_RETURN.MY_ONLINE_RETURN_PAGE_CURRENT:
        return Object.assign({},state,{
            MY_ONLINE_RETURN_PAGE_CURRENT: action.MY_ONLINE_RETURN_PAGE_CURRENT
        });
        break;

        case MY_ONLINE_RETURN.MY_ONLINE_RETURN_SHOW_COMMENTS:
        return Object.assign({},state,{
            MY_ONLINE_RETURN_SHOW_COMMENTS: action.MY_ONLINE_RETURN_SHOW_COMMENTS
        });
        break;

        case MY_ONLINE_RETURN.MY_ONLINE_RETURN_COMMENTS_NOW_OP:
        return Object.assign({},state,{
            MY_ONLINE_RETURN_COMMENTS_NOW_OP : action.MY_ONLINE_RETURN_COMMENTS_NOW_OP,
            MY_ONLINE_RETURN_COMMENTS_NOW_ORDER_ID : action.MY_ONLINE_RETURN_COMMENTS_NOW_ORDER_ID,
            MY_ONLINE_RETURN_COMMENTS_NOW_SKUID : action.MY_ONLINE_RETURN_COMMENTS_NOW_SKUID,
            MY_ONLINE_RETURN_SHOW_COMMENTS : action.MY_ONLINE_RETURN_SHOW_COMMENTS
        });
        break;

        case MY_ONLINE_RETURN.MY_ONLINE_RETURN_DOWN_PAY_BOX_SHOW:
        return Object.assign({},state,{
            MY_ONLINE_RETURN_DOWN_PAY_BOX_SHOW : action.MY_ONLINE_RETURN_DOWN_PAY_BOX_SHOW,
            MY_ONLINE_RETURN_NOW_PAY_ORDER_ID : action.MY_ONLINE_RETURN_NOW_PAY_ORDER_ID,
            MY_ONLINE_RETURN_NOW_PAY_MONEY : action.MY_ONLINE_RETURN_NOW_PAY_MONEY,
        });
        break;

        case MY_ONLINE_RETURN.MY_ONLINE_RETURN_CANCEL_REASON_SHOW:
        return Object.assign({},state,{
            MY_ONLINE_RETURN_CANCEL_REASON_SHOW : action.MY_ONLINE_RETURN_CANCEL_REASON_SHOW,
        });
        break;

        case MY_ONLINE_RETURN.MY_ONLINE_RETURN_ORDER_ID:
        return Object.assign({},state,{
            MY_ONLINE_RETURN_CANCEL_REASON_SHOW : action.MY_ONLINE_RETURN_CANCEL_REASON_SHOW,
            MY_ONLINE_RETURN_ORDER_ID : action.MY_ONLINE_RETURN_ORDER_ID,
            MY_ONLINE_RETURN_CANCEL_REASON_STATUS :action.MY_ONLINE_RETURN_CANCEL_REASON_STATUS,
        });
        break;

        case MY_ONLINE_RETURN.MY_ONLINE_RETURN_LOGISTIC_SHOW:
        return Object.assign({},state,{
            MY_ONLINE_RETURN_LOGISTIC_SHOW : action.MY_ONLINE_RETURN_LOGISTIC_SHOW,
            MY_ONLINE_RETURN_LOGISTIC_MODEL : action.MY_ONLINE_RETURN_LOGISTIC_MODEL,
            MY_ONLINE_RETURN_LOGISTIC_INDEX : action.MY_ONLINE_RETURN_LOGISTIC_INDEX,
        });
        break;
        
        case MY_ONLINE_RETURN.MY_ONLINE_RETURN_USER_PROFILE:
        return Object.assign({},state,{
            MY_ONLINE_RETURN_USER_PROFILE : action.MY_ONLINE_RETURN_USER_PROFILE,
        });
        break;

        default:
        return state;
        break;
    }
}


// WEBPACK FOOTER //
// ./common/reducers/myAccountOnlineReturn.js